<form class="block job job-form" [formGroup]="form" (ngSubmit)="onSubmit(); false" novalidate>
  <div class="field">
    <div class="d-flex">
      <div class="field-title">Job Title</div>
      <a class="delete-job-btn ml-auto" *ngIf="job" (click)="delete(job)">delete</a>
    </div>

    <input type="text" formControlName="name" placeholder="Text" />
  </div>
  <div class="field">
    <div class="field-title">Job Description</div>
    <div class="textarea-wrapper">
      <!--            <div-->
      <!--                class="textarea"-->
      <!--                contenteditable-->
      <!--                [textContent]="form.get('description').value"-->
      <!--                (input)="onChangeDescription($event.target.textContent)"-->
      <!--                placeholder="Job Description"-->
      <!--            ></div>-->
      <textarea
        class="textarea"
        [textContent]="form.get('description').value"
        (input)="onChangeDescription($event.target.value)"
        placeholder="Job Description"
      ></textarea>
    </div>
  </div>
  <div class="field">
    <div class="field-title">Contact Details</div>
    <input type="email" formControlName="email" placeholder="example@gmail.com" />
  </div>
  <div class="field">
    <div class="field-title">Contact URL</div>
    <input type="url" formControlName="url" placeholder="https://www.example.com" />
  </div>
  <div class="filed other d-flex">
    <mat-checkbox class="mr-4" formControlName="children">Student job</mat-checkbox>
    <mat-checkbox class="mr-4" formControlName="remote">Remote work</mat-checkbox>
  </div>
  <div class="job-actions">
    <ng-container *ngIf="!isCreatingNewJob; else creatingInProgress">
      <div class="btn action alt" (click)="onCancel(); false">Cancel</div>
      <button class="action" [disabled]="!form.valid">Post a Job</button>
    </ng-container>
    <ng-template #creatingInProgress>
      <app-loader-2></app-loader-2>
    </ng-template>
  </div>
</form>
